export const VysledekHlasovaniMoznost = {
    ACCEPTED: 1,
    REJECTED: 2
};

export const HlasovaciMoznost = {
    YES: 1,
    NO: 2,
    ABSTAIN: 3,
    NOT_VOTED: 4,
    ABSENT: 5,
    SECRET: 6,
    EXCUSED: 7
};

export const DochazkaMoznost = {
    PRESENT: 1,
    PART_PRESENT: 2,
    ABSENT: 3
};

export const UserRole = {
    USER: 1,
    ADMIN: 2
};

export const Permission = {
    MANAGE_MUNICIPALITY: 'manage_municipality'
};

export const ErrorCode = {
    TOKEN_EXPIRED: 40101,
    TOKEN_INVALID: 40102
};

export const VolitelnaVlastnost = {
    HISTORIE_UPRAV: 1
}

export const BackupTrigger = {
    MANUAL: 1,
    DELETION: 2,
    IMPORT: 3
}
